/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetAuditLogsQuery,
  AuditLogSearchFiltersInput,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  page: number;
  limit: number;
  timeRangeStart: string;
  timeRangeEnd: string;
  filters?: AuditLogSearchFiltersInput;
  skip?: boolean;
};

export function useGetAuditLogs({
  page,
  limit,
  timeRangeStart,
  timeRangeEnd,
  filters,
  skip,
}: Props) {
  const { data, loading, error } = useGetAuditLogsQuery({
    variables: {
      input: {
        page,
        limit,
        timeRangeStart,
        timeRangeEnd,
        filters,
      },
    },
    fetchPolicy: "cache-and-network",
    onError: (err) => {
      showError(err.message);
    },
    skip,
  });
  const count = data?.auditLogs?.count ?? 0;

  return {
    data: data?.auditLogs?.results ?? [],
    loading,
    error,
    count,
  } as const;
}
